import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { editContent } from '../../modules/editor';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { isNumber } from '../../util/validator';
import { getPathAfterBuild } from '../../util/file';

type Props = {
	target: string;
	value: string;
	option: any[]
};

function BorderStyleDropdown({ target, value, option }: Props) {
	const dispatch = useDispatch();
	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const [open, setOpen] = useState(false);
	const [inputValue, setInputValue] = useState(value);

	const toggleOpen = () => {
		setOpen(!open);
	}

	const onChangeInput = (e: any) => {
		const { value } = e.target;
		setInputValue(value);
	}

	useEffect(() => {
		setInputValue(value);		
	}, [value]);

	const ref = useRef(null);
	useOnClickOutside(ref, (): any => {
		setOpen(false);
		setInputValue(value);
	});

	const onClick = (item:any) => {
		dispatch(editContent({ target: target, data: item.value}));
		setOpen(false);
	}

	return (
		<div className="border-style-dropdown" ref={ref}>
			<button
				className={open ? 'btn border-style-dropdown-btn active' : 'btn border-style-dropdown-btn'}
				onClick={toggleOpen}
			>
				<span style={{borderStyle: value}} ></span>
				<ReactSVG className="caret" src={iconImage(`./icon/toolbar/arrow_down.svg`)} width="10" />
			</button>
			{
				open && (
					<div className="border-style-dropdown-body">
						{
							option.map((item:any, index:number) => (
								<button
									key={index}
									onClick={() => { onClick(item)}}
									className={(isNumber(item.value) ? `${item.value}px` : item.value) === (value === '0' ? '0px' : value) ? 'active' : ''}
								>
									<span style={{borderStyle: item.value}}></span>
								</button>		
							))
						}
					</div>
				)
			}
		</div>
	);
}

BorderStyleDropdown.defaultProps = {
};

export default BorderStyleDropdown;